function About() {
	return (
		<div className="scrollable-page">
		<div className="container">
			<h1>About</h1>
			<p><img height="32" width="32" src="https://cdn.simpleicons.org/react/61DAFB" alt="React logo" /> A React APP </p>
			<p><img height="32" width="32" src="https://cdn.simpleicons.org/markdown/" alt="Markdown logo" /> Made to handle Markdown </p>
			<p><img height="32" width="32" src="https://cdn.simpleicons.org/reactrouter/CA4245" alt="React Router logo" /> Navigation with React Router</p>
			<p><img height="32" width="32" src="https://cdn.simpleicons.org/bootstrap/7952B3" alt="Bootstrap logo" /> Styled with Bootstrap</p>
			<p><img height="32" width="32" src="https://kromatic.fr/wp-content/uploads/2019/08/KLogo_512_carré.png" alt="Kromatic logo" /> Created by Romain Koenig / <a href="https://kromatic.fr" target="_blank" rel="noopener noreferrer">Kromatic</a></p>
			<p><img height="32" width="32" src="https://cdn.simpleicons.org/github/181717" alt="GitHub logo" /> Hosted on GitHub Pages</p>

			<p>Welcome to one of my pet projects, the Markdown to PDF Converter.<br />
				This project was born out of my passion for learning and my desire to deepen my understanding of React and GitHub Pages.
				It represents 24 hours, from idea to MVP, of coding, and debugging – all with the aim to create a useful tool (at least for myself) and improve my development skills.
				As you explore this app, please handle it with care.<br />
				Your feedback and suggestions are always welcome as they contribute to my learning process.<br />
				Enjoy converting your Markdown to PDF, and thank you for being a part of this!</p>
			<p>More work from me on my <a href="https://portfolio.krokee.fr" target="_blank" rel="noopener noreferrer">Portfolio</a>.</p>

			<p>This application was developed with assistance from <a href="https://github.com/features/copilot" target="_blank" rel="noopener noreferrer">GitHub Copilot</a> and <a href="https://claude.ai/code" target="_blank" rel="noopener noreferrer">Claude Code</a>.</p>

			<h2>Respecting Your Privacy</h2>
			<p>
				The tool Markdown-to-PDF prioritizes your privacy. Here are the key points you should know about how we handle your data:
			</p>
			<ol>
				<li>
					<strong>No Tracking:</strong> We do not use any tracking tools or analytics that would monitor your usage of our application. Your activity on our site is not tracked or recorded.
				</li>
				<li>
					<strong>Data Stays Local:</strong> Any data you input into this application stays in your browser. We don't store or process any of your data on our servers. Everything you type or convert using this tool remains on your local machine.
				</li>
				<li>
					<strong>Open Source:</strong> Our application is open-source. You can view our source code on <a href="https://github.com/romain-koenig/markdown-to-pdf" target="_blank" rel="noopener noreferrer">GitHub</a> to see exactly how it works. We believe in transparency, and we invite you to explore and contribute to our codebase.
				</li>
			</ol>
			<p>
				My aim is to provide a tool that respects user privacy and promotes free software and transparency. I hope you find Markdown-to-PDF useful and trustworthy.
			</p>


		</div>
		</div>

	);
}

export default About;
